(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collapsible-tab-thyrsus-core"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('thyrsus-accordion-text')) {
    customElements.define('thyrsus-accordion-text', class extends HTMLElement {
      connectedCallback() {
        window.requestAnimationFrame(() => {
          const meaningfulElements = 'img, picture, video, audio, iframe, canvas, object, embed, input, button, select, textarea, a[href], svg path, svg rect, svg circle, svg polygon, svg polyline, svg line, svg ellipse, svg use, [aria-label]:not([aria-label=""])';
          this.querySelectorAll('.custom-liquid[data-shopify-editor-block], .thyrsus-product-accordion[data-shopify-editor-block]').forEach(fragment => {
            if (fragment.textContent.trim() || fragment.getAttribute('aria-label')?.trim() || fragment.querySelector(meaningfulElements)) return;
            fragment.remove();
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["thyrsus-pdp-facts"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const picker = event.target.closest('variant-picker');
    if (!picker) return;
    const summary = picker.closest('.main-product')?.querySelector('[data-thyrsus-summary-material]');
    if (!summary) return;
    const fields = picker.querySelectorAll('input[type="radio"]:checked, select');
    for (const field of fields) {
      if (field.name.replace(/^options\[/i, '').replace(/\]$/, '').trim().toLowerCase() === 'base material') {
        summary.textContent = field.value;
        break;
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
